/**
 * Firebase v9+ httpsCallable resolves to HttpsCallableResult: { data }.
 * Normalize so callers can read payload fields reliably.
 */
export function getCallablePayload(result) {
  if (result && typeof result === "object" && "data" in result) {
    return result.data;
  }
  return result;
}
